import { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { slideIndex } from '../../store';
import useWindowScroll from '../hooks/useWindowScroll';
import TopArrow from '../vector/common/TopArrow';

export default function TopButton({
  isMain,
  slideIdx,
}: {
  isMain?: boolean;
  slideIdx?: number;
}) {
  const setIndex = useSetRecoilState(slideIndex);
  const { scrollY } = useWindowScroll();
  const goTop = () => {
    if (isMain) {
      setIndex(0);
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };
  const isVisible = () => {
    if (isMain) {
      return slideIdx && slideIdx > 0 ? true : false;
    } else {
      return scrollY >= 500 ? true : false;
    }
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile(); 
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <>
      {isVisible() && (
        <button
          onClick={goTop}
          className="top-button fixed z-10 w-[60px] h-[60px] rounded-full border border-gray3 bg-white flex justify-center items-center max-md:w-10 max-md:h-12"
          style={{ right: isMobile ? '1.6rem' : '2rem', bottom: isMobile ? '5.3rem' : '6.8rem'}}
        >
          <TopArrow />
        </button>
      )}
    </>
  );
}
